/**
 * Indian number formatting helpers (Lakh / Crore notation).
 */

/**
 * Format a number using the Indian numeric system.
 * - >= 1 Crore: "1.25 Cr"
 * - >= 1 Lakh:  "2.51 L"
 * - >= 1 Thousand: "2,500" (comma-grouped Indian style via toLocaleString('en-IN'))
 * - 0–999: as-is
 *
 * @param {number} n
 * @param {Object} opts
 * @param {number} opts.precision - decimals for Cr/L (default 2)
 * @returns {string}
 */
export const formatIndian = (n, { precision = 2 } = {}) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const v = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (v >= 1_00_00_000) return `${sign}${(v / 1_00_00_000).toFixed(precision).replace(/\.?0+$/, '')} Cr`;
  if (v >= 1_00_000)    return `${sign}${(v / 1_00_000).toFixed(precision).replace(/\.?0+$/, '')} L`;
  return n.toLocaleString('en-IN');
};

/**
 * Format a value already given in Lakh units back to a friendly Indian string.
 * e.g. lakhsToIndian(1980) → "19.8 Cr (1,980 L)"
 */
export const lakhsToIndian = (lakhs) => {
  if (lakhs >= 100) {
    const cr = lakhs / 100;
    return `${cr.toFixed(2).replace(/\.?0+$/, '')} Cr`;
  }
  return `${lakhs.toLocaleString('en-IN')} L`;
};
